<template>
  <div>
    <div v-for="event in events" :key="event.id" style="margin-bottom: 15px">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>
            {{ event.date | moment("Do MMMM YYYY") }},
            {{ event.room | capitalize }}
            <span class="grey--text" v-if="event.type !== 'register'"
              >({{ event.percentBooked }}% booked) ({{ event.bookedCount }}/{{
                event.slotCount
              }})</span
            >
          </v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-chip color="grey lighten-1" small>{{ event.code }}</v-chip>
          <v-menu left bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" class="hp--btn">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="csvDownloadAll(events)">
                <v-list-item-title>CSV (All Groups)</v-list-item-title>
              </v-list-item>
              <v-list-item @click="csvDownload(event)">
                <v-list-item-title>CSV (This Group)</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>

        <v-divider></v-divider>
        <v-data-table
          :items="event.slot"
          :headers="slotHeader"
          class="elevation-1"
          :sort-by="['time']"
          :sort-desc="[false]"
          :items-per-page="-1"
        >
          <template v-slot:item.name="{ item }"
            >{{ item.firstname | capitalize }}
            {{ item.lastname | capitalize }}</template
          >
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
export default {
  props: {
    events: Array
  },
  data() {
    return {
      booking: [],
      collectUserDatas: [],
      createBookingDialog: false,
      createBookingLoader: false,
      rules: {
        required: v => !!v || "This field is required.",
        email: v => /.+@.+\..+/.test(v) || "E-mail must be valid",
        confirmEmail: v =>
          v === this.booking.email || "Confirmation email must match email"
      },
      slotHeader: [{ text: "Name", value: "name" }],
      message: {
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000
      }
    };
  },
  methods: {
    csvDownload(download) {
      let bookingTableData = [];
      download.slot.map(event => {
        if (event.id) {
          bookingTableData.push({
            firstname: event.firstname,
            lastname: event.lastname
          });
          if (event.customData) {
            let customData = JSON.parse(event.customData);
            if (customData) {
              let key = Object.keys(customData)[0];
              bookingTableData[bookingTableData.length - 1][key] =
                customData[Object.keys(customData)[0]];
            }
          }
        }
      });
      if (bookingTableData.length > 0) {
        bookingTableData = _.orderBy(bookingTableData, "time", "asc");
        this.csvExport(bookingTableData);
      } else {
        this.showSuccessMessage("No CSV results");
      }
    },
    csvDownloadAll(events) {
      let bookingTableData = [];
      events.forEach(function(event) {
        event.slot.forEach(function(slot) {
          if (slot.id) {
            bookingTableData.push({
              firstname: slot.firstname,
              lastname: slot.lastname
            });
            if (slot.customData) {
              let customData = JSON.parse(slot.customData);
              if (customData) {
                let key = Object.keys(customData)[0];
                bookingTableData[bookingTableData.length - 1][key] =
                  customData[Object.keys(customData)[0]];
              }
            }
          }
        });
      });
      if (bookingTableData.length > 0) {
        bookingTableData = _.orderBy(bookingTableData, ["firstName", "asc"]);
        this.csvExport(bookingTableData);
      } else {
        this.showSuccessMessage("No CSV results");
      }
    },
    csvExport(tableData) {
      const arrData = tableData;
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(arrData[0]).join(","),
        ...arrData.map(item => Object.values(item).join(","))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
    },
    showSuccessMessage(message) {
      this.message.snackbarText = message;
      this.message.snackbar = true;
    }
  }
};
</script>
